import styled from 'styled-components';
import { colors } from '../../utils/colors';
import { bootstrapMax, bootstrapMin } from '../../utils/devices';
import { Col, Row } from 'react-bootstrap';

export const RowStyled = styled(Row)`
  width: 100%;
  min-height: ${({ min_height }) => (min_height ? min_height : 58)}px;

  @media ${bootstrapMin.sm} {
    min-height: ${({ min_height_sm }) => (min_height_sm ? min_height_sm : 86)}px;
  }

  @media (max-width: 370px) {
    ${({ image }) => image && 'min-height: 269px;'}
  }
`;

export const RowBackStyled = styled(Row)`
  width: 100%;
  min-height: ${({ min_height }) => (min_height ? min_height : 58)}px;

  @media ${bootstrapMin.sm} {
    min-height: ${({ min_height_sm }) => (min_height_sm ? min_height_sm : 86)}px;
  }

  @media (max-width: 575px) {
    z-index: 100;
  }
`;

export const SubHeaderDefault = styled.div`
  z-index: -1;
  min-height: ${({ minHeight }) => (minHeight ? minHeight : 58)}px !important;
  position: absolute;
  width: 100vw;
  margin-left: -50vw;
  left: 49.99%;
  background-repeat: no-repeat;
  background-position: center;
  background-color: ${({ backgroundColor }) =>
    backgroundColor ? backgroundColor : colors.supportOne};
  background-image: ${({ backgroundImageMobile }) =>
    backgroundImageMobile ? `url(${backgroundImageMobile})` : 'none'};

  @media ${bootstrapMin.sm} {
    min-height: ${({ minHeightSm }) => (minHeightSm ? minHeightSm : 86)}px !important;
    background-image: ${({ backgroundImage }) =>
      backgroundImage ? `url(${backgroundImage})` : 'none'};
    background-size: 1366px ${({ minHeightSm }) => (minHeightSm ? minHeightSm : 86)}px !important;
  }

  @media ${bootstrapMax.sm} {
    background-size: 100%;
  }

  @media (max-width: 370px) {
    min-height: 269px !important;
  }
`;

export const SubHeaderBack = styled(SubHeaderDefault)`
  @media (max-width: 575px) {
    position: fixed;
    z-index: 50;
    border-radius: 15px;
    min-height: 58px !important;
  }
`;

export const ColStyled = styled(Col)`
  @media (max-width: 575px) {
    position: fixed;
  }
`;
